import { ProductParams } from 'types/getParams';
import { TProduct } from 'types/product';

import { CRMAPIBase } from '@api/crmApiBase';
import {
    BaseProductListResp,
    BaseProductResp,
} from '@api/responseModels/product/baseProductResponse';
import { BaseProductModerationLogListResp } from '@api/responseModels/product/baseProductModerationLogResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class ProductAdminGroup extends CRMAPIBase {
    async getAdminBaseProducts(
        page = 1,
        categoryId = 1,
        moderateStatus?: string[]
    ): Promise<RequestResult<BaseProductListResp>> {
        const result = await this.get<BaseProductListResp>('/admin/base-products', {
            page,
            category_id: categoryId,
            ...(moderateStatus?.length ? { filters: { moderate_status: moderateStatus } } : {}),
        });
        return result;
    }

    async getAdminBaseProduct(id: number): Promise<RequestResult<BaseProductResp>> {
        const result = await this.get<BaseProductResp>(`/admin/base-products/${id}`);
        return result;
    }

    async createAdminBaseProduct(params: ProductParams): Promise<RequestResult<BaseProductResp>> {
        const result = await this.post<BaseProductResp>(`/admin/base-products/`, params);
        return result;
    }

    async updateAdminBaseProduct(params: TProduct): Promise<RequestResult<BaseProductResp>> {
        const result = await this.put<BaseProductResp>(
            `/admin/base-products/${params.id}`,
            params
        );
        return result;
    }

    async deleteAdminBaseProduct(params: { id: number }): Promise<RequestResult<BaseProductResp>> {
        const result = await this.delete<BaseProductResp>(`/admin/base-products/${params.id}`);
        return result;
    }

    async getAdminBaseProductModerationLogs(
        id: number
    ): Promise<RequestResult<BaseProductModerationLogListResp>> {
        const result = await this.get<BaseProductModerationLogListResp>(
            `/admin/base-products/${id}/moderation-logs`
        );
        return result;
    }
}
export { ProductAdminGroup };
